import { render, staticRenderFns } from "./Taxonomies.vue?vue&type=template&id=ae00b9d0&scoped=true&"
import script from "./Taxonomies.vue?vue&type=script&lang=js&"
export * from "./Taxonomies.vue?vue&type=script&lang=js&"
import style0 from "./Taxonomies.vue?vue&type=style&index=0&id=ae00b9d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae00b9d0",
  null
  
)

export default component.exports